import { AnalyseConstants } from '../../../_constants';

const initialState = { saveAssesorGroupListLoading: true, data: '', error: false, relationFilterUsed: false };

export function saveAssesorGroupListReducer(state = initialState, action) {
   
    switch (action.type) {
        case AnalyseConstants.REQUEST_SAVE_ASSESOR_GROUPS:
        return {
            saveAssesorGroupListLoading: false,
            data: state.data,
            error: false,
            relationFilterUsed: action.relationFilterUsed ? action.relationFilterUsed : false
        };
        case AnalyseConstants.RECEIVE_SAVE_ASSESOR_GROUPS:
            return {
                saveAssesorGroupListLoading: false,
                data: action.data,
                error: false,
                relationFilterUsed: false
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyse/AssessorList/saveAssessorGroupList.reducer.js